import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Button as Btn, Typography } from "@material-ui/core";
import { DarkGrey } from "../../shared/styles/colors";
import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";
import GmailIcon from "../../assets/social-media/google-gmail-icon.svg";
import MessengerIcon from "../../assets/social-media/messenger-icon.svg";
import WhatsappIcon from "../../assets/social-media/whatsapp-icon.svg";
import CopyLinkButton from "../../shared/components/buttons/CopyLinkButton";
import useStyles from "./styles";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30rem",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "88%",
  },
};

interface ShareButtonProps {
  url: string;
  title?: string;
  text?: string;
}

const ShareModal: React.FC<ShareButtonProps> = ({ url, title, text }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title || "Share this link",
          text: text || "Check this out!",
          url: url,
        });
      } catch (err) {
        console.log("Share was cancelled: ", err);
      }
    } else {
      // Fallback for browsers that don't support Web Share API
      //copyToClipboard();
      alert("Link copied to clipboard!");
    }
  };

  return (
    <div>
      <Btn style={{ textTransform: "none" }} onClick={handleOpen}>
        <ShareIcon style={{ color: DarkGrey }} />
        Share
      </Btn>
      {open && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ overflowY: "auto" }}
        >
          <Box sx={style}>
            <div className={classes.headerDiv}>
              <Typography className={classes.title}>Share options</Typography>
              <Button onClick={handleClose} sx={{ color: DarkGrey }}>
                <CloseIcon />
              </Button>
            </div>
            <hr />
            <div>
              <Typography>Share via</Typography>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                  marginBottom: "20px",
                }}
              >
                <Btn onClick={handleNativeShare}>
                  <img src={GmailIcon} alt="gmail icon" />
                </Btn>
                <Btn onClick={handleNativeShare}>
                  <img src={MessengerIcon} alt="messenger icon" />
                </Btn>
                <Btn onClick={handleNativeShare}>
                  <img src={WhatsappIcon} alt="whatsapp icon" width={30}/>
                </Btn>
              </div>
              <Typography>Or copy link</Typography>
              <CopyLinkButton link={url} displayText={text} />
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
};

export default ShareModal;
